export default __webpack_public_path__ + "static/media/graph.bbd2f12f.png";